// extracted by mini-css-extract-plugin
module.exports = {"SizeGuide":"SizeGuide-SizeGuide-1M4Wt5","SizeGuideTable":"SizeGuide-SizeGuideTable-1U_3oR"};